export default "/media/images/anonymous-avatar.png"